import React, { useCallback, useEffect, useState } from 'react';
import { Popover, Button } from '@patternfly/react-core';
import { useDebouncyEffect } from 'use-debouncy';
import { HexColorPicker, HexColorInput } from 'react-colorful';
import PropTypes from 'prop-types';
import { ModelPropType } from '../ModelPropTypes';
import { useTranslation } from '../../../localization/useTranslation';
import './ColorPickerComponent.css';
import { defaultColors } from '../../../utils/colors';
import _ from 'lodash';

const ColorButton = ({ color, onClick }) => {

  return (
    <Button
      key={color}
      className="picker__swatch"
      style={{ background: color }}
      onClick={onClick}
    />

  );
};

const ColorPickerComponent = ({ model, value, onChange }) => {
  const T = useTranslation();
  const [color, setColor] = useState(value);
  const [customColors, setCustomColors] = useState([]);

  useEffect(() => {
    setCustomColors(JSON.parse(localStorage.getItem('color-picker-custom-colors') || '[]'));
  }, [color]);

  useEffect(() => {
    setColor(value);
  }, [value]);

  useDebouncyEffect(() => onChange({ path: model.path }, color), 200, [color]);

  const handleAddCustomColor = useCallback((color) => {
    const newColors = [
      ...customColors,
      color
    ];

    localStorage.setItem('color-picker-custom-colors', JSON.stringify(newColors));
    setCustomColors(newColors);
  }, [customColors]);

  return (
    <Popover
      bodyContent={
        <div className="picker">
          <HexColorPicker
            id={model.path}
            color={color}
            onChange={setColor}
          />

          <div className="picker__container">
            <HexColorInput color={color} onChange={setColor} />
          </div>

          <div className="picker__container">
            <Button isBlock variant="secondary" onClick={() => handleAddCustomColor(color)}>{ T.colorPicker.addCustomColor }</Button>
          </div>
          <div className="picker__container">
            { T.colorPicker.defaultColors }
          </div>
          <div className="picker__swatches">
            { _.map(defaultColors, (color, key) => (<ColorButton key={key} color={color} onClick={() => setColor(color)} />)) }
          </div>

          <div className="picker__container">
            { T.colorPicker.customColor }
          </div>
          <div className="picker__swatches">
            { _.map(customColors, (color, key) => (<ColorButton key={key} color={color} onClick={() => setColor(color)} />)) }
          </div>
        </div>
      }
    >
      <Button
        style={{
          backgroundColor: color,
          height: model.properties?.height || '28px',
          width: model.properties?.width || '28px'
        }}
      />
    </Popover>
  );
};

ColorPickerComponent.propTypes = {
  model: ModelPropType,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

export default React.memo(ColorPickerComponent);
